<template>
  <div id="page-top">
    <div id="wrapper">
      <Sidebar :vendorId="user.vendorId" />
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          <Navbar :vendorId="user.vendorId" />
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/modules/store";
import "../assets/temp/style.min.css";
import Navbar from "@/components/admin/Navbar.vue";
import Sidebar from "@/components/admin/Sidebar.vue";
import Footer from "@/components/admin/Footer.vue";
import { dbFs } from "@/modules/database";
import { mapGetters } from "vuex";
export default {
  data: () => {
    return {
      navbar: true,
      user: []
    };
  },
  computed: {
    ...mapGetters({
      users: "getUser"
    })
  },
  mounted() {
    this.check_url();
    this.setupFirebaseReading();
  },
  methods: {
    setupFirebaseReading: function() {
      if (this.users) {
        this.loading = true;
        this.$bind("user", dbFs.collection("user").doc(this.users.uid))
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            store.dispatch("clearVendorId");
            store.dispatch({
              type: "updateVendorId",
              VendorId: this.user.vendorId
            });
            this.loading = false;
          });
      }
    },
    check_url() {
      if (this.$route.params.device_type == "app") {
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    }
  },
  components: {
    Navbar,
    Sidebar,
    Footer
  },
  watch: {
    $route() {
      if (this.$route.params.device_type == "app") {
        this.check_url();
      }
    },
    users() {
      if (this.users) {
        this.setupFirebaseReading();
      }
    }
  }
};
</script>
<style scoped>
@import url("https://blackrockdigital.github.io/startbootstrap-sb-admin-2/vendor/datatables/dataTables.bootstrap4.min.css");
</style>
